import { Box } from '@mentimeter/ragnar-ui/box';

export const EditorLayout = ({
  children,
  direction = 'row',
}: { children: React.ReactNode; direction?: 'row' | 'column' }) => (
  <Box
    as="main"
    flex="1 1 auto"
    flexDirection={direction}
    width="100%"
    height="100%"
    bg="surfaceSunken"
    alignItems="stretch"
  >
    {children}
  </Box>
);
